import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { SpareParts } from '../models/footer.model';
import { PagesList } from '../components/footer-legals/models/pages.model';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private http = inject(HttpClient);
  private urlApi: string;
  private headers = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor() {
    this.urlApi = environment.apiURL;
  }

  getCategories(): Observable<SpareParts[]> {
    return this.http.get<SpareParts[]>(this.urlApi + 'parts-categories/', this.headers);
  }

  getAllPages(): Observable<PagesList[]> {
    return this.http.get<PagesList[]>(this.urlApi + 'pages/', this.headers);
  }
}
